import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    overflow: hidden;
    border-radius: 4px;
`
const Buttons = styled.button`
  color: ${props => props.isChecked ? '#FFF' : '#4A4A4A'};
  background-color: transparent;
  height: 20px;
  width: 22px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border: solid 0.5px transparent;
`
export const Check = styled.img`
    width: inherit;
    height: inherit;
    cursor: pointer;
    border-radius: 4px;
    @media (max-width: 763px) {
      width: 15px;
      height: 15px;
    }
`

const CheckDisabled = styled.div`
    height: 20px;
    width: 22px;
    border-radius: 4px;
    background: #c7c7c7;
    cursor: not-allowed; 
`

const CheckBtn = ({id, checked, onCheck, disabled}) => (
    <Container isChecked={checked} >
      {
          disabled 
          ? 
              <CheckDisabled />
          :
              <Buttons onClick={() => onCheck(id)} isChecked={checked}>
                <Check src={checked ? "/assets/check.svg" : "/assets/checkmark.svg" } checked={checked}/>
              </Buttons>
      }
    </Container>
)

export default CheckBtn



// WEBPACK FOOTER //
// ./src/Containers/VideoGenerator/components/CheckBtn/CheckBtn.jsx